import * as DateFns from "date-fns"

export const formatToDate = (date: Date | string) => {
  const dateObject =
    typeof date === "string"
      ? DateFns.parse(date, "yyyy-MM-dd", new Date())
      : date

  return DateFns.format(dateObject, "EEE do MMM")
}
